export const getNumberOfVulnerabilities = (item) => {
  return item.numVulnerabilities
    ? Object.values(item.numVulnerabilities).reduce((a, b) => a + b, 0)
    : 0
}

export const twoDecimals = (n) => {
  var log10 = n ? Math.floor(Math.log10(n)) : 0,
    div = log10 < 0 ? Math.pow(10, 1 - log10) : 100

  return Math.round(n * div) / div
}

export const UTCDate = (date) => {
  if (date.slice(-1) !== 'Z' && date.slice(-1) !== 'z') {
    date += 'Z'
  }
  return date
}

export const downloadObjectAsJson = ({ data, name }) => {
  const dataStr =
    'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(data))
  const downloadAnchorNode = document.createElement('a')
  downloadAnchorNode.setAttribute('href', dataStr)
  downloadAnchorNode.setAttribute('download', name + '.json')
  document.body.appendChild(downloadAnchorNode) // required for firefox
  downloadAnchorNode.click()
  downloadAnchorNode.remove()
}

export const normalizeMs = ({ runtimeInMs }) => {
  const runtimeInSecs = Math.floor(runtimeInMs / 1000)

  if (runtimeInMs < 120) {
    return `${runtimeInSecs} seconds`
  }

  if (runtimeInSecs < 3600 * 2) {
    const elapsed = Math.floor(runtimeInSecs / 60)
    return `${elapsed} minute${elapsed > 1 ? 's' : ''}`
  } else {
    const elapsed = Math.floor(runtimeInSecs / 60 / 60)
    return `${elapsed} hour${elapsed > 1 ? 's' : ''}`
  }
}

export const CAMPAIGN_STATUS = {
  RUNNING: 'running',
  STOPPED: 'stopped',
  STOPPING: 'stopping',
  STARTING: 'starting',
  IDLE: 'idle'
}

export const campaignIsActive = (status) => {
  const { RUNNING, STOPPED, STOPPING, STARTING } = CAMPAIGN_STATUS
  switch (status) {
    case STOPPED: {
      return false
    }
    case STOPPING: {
      return true
    }
    case STARTING: {
      return true
    }
    case RUNNING: {
      return true
    }
    default:
      return false
  }
}

export const getCampaignRuntime = ({ campaignMetadata }) => {
  // returns the time a campaign has been running for in miliseconds.
  try {
    const { status, stoppedAt, submittedAt } = campaignMetadata
    if (!submittedAt) {
      throw new Error(
        'Unable to compute runtime: submittedAt is not available.'
      )
    }
    let runtime
    if (status === CAMPAIGN_STATUS.IDLE) {
      runtime = 0
    }
    else if (!campaignIsActive(status)) {
      if (!stoppedAt) {
        throw new Error(
          'Unable to compute runtime: Campaign is stopped but stoppedAt or submittedAt are not available.'
        )
      }
      runtime = new Date(stoppedAt) - new Date(submittedAt)
    }
    else if (campaignIsActive(status)) {
      runtime = new Date() - new Date(submittedAt)
    }
    return normalizeMs({ runtimeInMs: runtime })
  } catch (e) {
    console.error(e)
    return -1
  }
}

export const getApiKeyPrefix = ({ auth0ClientId, auth0Domain }) => {
  return btoa(`${auth0ClientId}::${auth0Domain}`)
}

export const getMonthName = (monthNumber) => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ]
  return months[monthNumber - 1]
}

export const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

// todo: remove this function
export const appendLargerCoverageToReport = (report) => {
  const tempReport = JSON.parse(JSON.stringify(report))
  
  let currentPercentage = JSON.parse(tempReport[0].meta["PercentageCoverageOverTime"])
  const [timestamp, percentage] = currentPercentage[currentPercentage.length-1]
  const increasedTimestamp = Math.floor(timestamp+(timestamp*0.1))
  const increasedPercentage = Math.floor(percentage+1)
  currentPercentage = [...currentPercentage, [increasedTimestamp, increasedPercentage]]
  tempReport[0].meta.PercentageCoverageOverTime = JSON.stringify(currentPercentage)
  return tempReport
}

export const appendIssueToReport = (report) => {
  const templateIssue = {
    "uuid": ""+Math.floor(Math.random()*100000),
    "swcID": "SWC-110",
    "swcTitle": "Assert Violation",
    "description": {
      "head": "A user-provided assertion failed.",
      "tail": "A user-provided assertion failed with the message '0: balances are in sync'."
    },
    "severity": "Low",
    "locations": [
      {
        "sourceMap": "3903:42:3",
        "sourceType": "solidity-file",
        "sourceFormat": "text",
        "sourceList": [
          "",
          "/Users/boss/git/mythx/test-projects/scribble-exercise-1/contracts/__scribble_ReentrancyUtils.sol",
          "",
          "/Users/boss/git/mythx/test-projects/scribble-exercise-1/contracts/vulnerableERC20.sol"
        ]
      }
    ],
    "extra": {
      "discoveryTime": 180838494811,
      "testCases": [
        {
          "initialState": {
            "accounts": {
              "0x0000000000000000000000000000000000000000": {
                "nonce": 0,
                "balance": "0x000000000000000000000000000000000000000000000000000a9e765ebed200",
                "code": "",
                "storage": {
                  
                }
              },
              "0x90f8bf6a479f320ead074411a4b0e7944ea8c9c1": {
                "nonce": 1,
                "balance": "0x00000000000000000000000000000000000000fffffffffffff56189a1412dff",
                "code": "",
                "storage": {
                  
                }
              },
              "0xaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa0": {
                "nonce": 0,
                "balance": "0x00000000000000000000000000000000000000ffffffffffffffffffffffffff",
                "code": "",
                "storage": {
                  
                }
              },
              "0xaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa1": {
                "nonce": 0,
                "balance": "0x0000000000000000000000000000000000000000000000000000000000000000",
                "code": "",
                "storage": {
                  
                }
              },
              "0xaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa2": {
                "nonce": 0,
                "balance": "0x0000000000000000000000000000000000ffffffffffffffffffffffffffffff",
                "code": "",
                "storage": {
                  
                }
              },
              "0xaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa3": {
                "nonce": 1,
                "balance": "0x00000000000000000000000000000000000000ffffffffffffffffffffffffff",
                "code": "0x00",
                "storage": {
                  
                }
              },
              "0xaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa4": {
                "nonce": 1,
                "balance": "0x00000000000000000000000000000000000000ffffffffffffffffffffffffff",
                "code": "0xfd",
                "storage": {
                  
                }
              },
              "0xaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa5": {
                "nonce": 1,
                "balance": "0x00000000000000000000000000000000000000ffffffffffffffffffffffffff",
                "code": "0x608060405260005600a165627a7a72305820466f8a1bdae15c60b8e998fe04836ef505803cfbd8edd29bd4679531357576530029",
                "storage": {
                  
                }
              },
              "0xaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa6": {
                "nonce": 1,
                "balance": "0x00000000000000000000000000000000000000ffffffffffffffffffffffffff",
                "code": "0x608060405273aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa63081146038578073ffffffffffffffffffffffffffffffffffffffff16ff5b5000fea165627a7a723058205e8b906b72ad42c69b05acf4542283b6080ae82562bc74baac467daac2fb0e0e0029",
                "storage": {
                  
                }
              },
              "0xe78a0f7e598cc8b0bb87894b0f60dd2a88d6a8ab": {
                "nonce": 1,
                "balance": "0x0000000000000000000000000000000000000000000000000000000000000000",
                "code": "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",
                "storage": {
                  "0x0000000000000000000000000000000000000000000000000000000000000000": "0x0000000000000000000000000000000000000000000000000000000000000001",
                  "0x0000000000000000000000000000000000000000000000000000000000000001": "0x00000000000000000000000000000000000000000000000000000000000f4240",
                  "0x0000000000000000000000000000000000000000000000000000000000000003": "0x0000000000000000000000000000000000000000000000000000000000000002",
                  "0x0000000000000000000000000000000000000000000000000000000000000005": "0x00000000000000000000000000000000000000000000000000000000000f4240",
                  "0xaccdee18023550db6934125b989726b403f859182b9c551ed8c7b4e686303ae1": "0x0000000000000000000000000000000000000000000000000000000000000001",
                  "0xc2575a0e9e593c00f959f8c92f12db2869c3395a3b0502d05e2516446f71f85c": "0x00000000000000000000000090f8bf6a479f320ead074411a4b0e7944ea8c9c1",
                  "0xc30df1b2c125b5153defa9414be9c4af8ad07fe9601dbf6e43a237213263cbf9": "0x00000000000000000000000000000000000000000000000000000000000f4240"
                }
              }
            }
          },
          "steps": [
            {
              "address": "0xe78a0f7e598cc8b0bb87894b0f60dd2a88d6a8ab",
              "gasLimit": "0xff000",
              "gasPrice": "0x156dd3d6d",
              "input": "0xa9059cbb00000000000000000000000090f8bf6a479f320ead074411a4b0e7944ea8c9c100000000000000000000000000000000000000000000000000000000000f3dfa0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
              "origin": "0x90f8bf6a479f320ead074411a4b0e7944ea8c9c1",
              "value": "0x0",
              "blockCoinbase": "0xaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa0",
              "blockDifficulty": "0x0",
              "blockGasLimit": "0xff0000",
              "blockNumber": "0x54",
              "blockTime": "0x63efbe59",
              "decodedInput": "transfer(0x90f8bf6a479f320ead074411a4b0e7944ea8c9c1, 998906)",
              "name": "transfer(address,uint256)"
            }
          ]
        }
      ],
      "harveyId": 20,
      "debugInfo": {
        "0": {
          "stackTrace": "/Users/boss/git/mythx/test-projects/scribble-exercise-1/contracts/vulnerableERC20.sol:91:17 VulnerableToken.__scribble_VulnerableToken_check_state_invariants_internal()\n/Users/boss/git/mythx/test-projects/scribble-exercise-1/contracts/vulnerableERC20.sol:98:8 VulnerableToken.__scribble_check_state_invariants()\n/Users/boss/git/mythx/test-projects/scribble-exercise-1/contracts/vulnerableERC20.sol:40:8 VulnerableToken.transfer(0x90f8bf6a479f320ead074411a4b0e7944ea8c9c1, 998906)",
          "debugVariables": {
            "_totalSupply": "1000000"
          }
        }
      }
    },
    "decodedLocations": [
      [
        {
          "line": 91,
          "column": 18
        },
        {
          "line": 91,
          "column": 60
        },
        false
      ]
    ]
  }
  let newReport = JSON.parse(JSON.stringify(report))
  newReport[0].issues = [...newReport[0].issues, templateIssue]
  return newReport
}

